import { atom, selector } from 'recoil';
import { BuilderAnswers, BuilderOutput, EMPTY_ANSWERS, Issue } from 'helpers/kpiBuilder/types';

// What the admin has answered in the KPI Builder.
export const builderAnswersState = atom<BuilderAnswers>({
  key: 'builderAnswers',
  default: EMPTY_ANSWERS,
});

// true: the guided builder drives Data / Filters / Additional Config; false: the raw JSON editors do.
export const builderModeState = atom<boolean>({
  key: 'builderMode',
  default: true,
});

// The query and config generated from the current answers (null until the Data tab is complete).
export const builderOutputState = atom<BuilderOutput | null>({
  key: 'builderOutput',
  default: null,
});

// Errors and warnings for the current answers, shown as banners on each tab.
export const builderIssuesState = atom<Issue[]>({
  key: 'builderIssues',
  default: [],
});

// Text the admin typed over the generated query/config; null means the generated one is in use.
export interface BuilderEdits {
  query: string | null;
  config: string | null;
}

export const NO_BUILDER_EDITS: BuilderEdits = { query: null, config: null };

export const builderEditsState = atom<BuilderEdits>({
  key: 'builderEdits',
  default: NO_BUILDER_EDITS,
});

// The output as it will be saved: the generated one with any hand edits laid over it.
export const builderEffectiveOutputState = selector<BuilderOutput | null>({
  key: 'builderEffectiveOutput',
  get: ({ get }) => {
    const output = get(builderOutputState);
    const { query, config } = get(builderEditsState);
    if (!output || (query === null && config === null)) return output;
    return {
      ...output,
      ...(query === null ? {} : { queryString: JSON.stringify(JSON.parse(query)) }),
      ...(config === null ? {} : { config: JSON.parse(config) as BuilderOutput['config'] }),
    };
  },
});
